import React from "react";
import "./Spinner2.css";

const Spinner2 = () => {
  return (
    <div className="spinner2">
      <div className="double-bounce1" />
      <div className="double-bounce2" />
    </div>
  );
};

export default Spinner2;
